import { InternalAxiosRequestConfig } from 'axios';
import { unSupportedLanguages } from '@shared/i18n/config/language';
import { getI18nSetting } from '@shared/i18n/route';
import { LSK } from '@shared/utils/storage/config';
import { loadOneTimeData } from '@shared/utils/storage/onetime';

import {
	CREATE_ENDPOINTS,
	CREDITS_CONSUMING_ENDPOINTS,
	GENERATE_ENDPOINTS,
	I18N_ENDPOINTS,
	Optimize_ENDPOINTS,
} from '../config';
import { HttpDependency } from '../dependency';
import { UserChannelVersionMap, useUserTypeStore } from '@/mobile/store/UserType';
import { isMobileOnly } from 'react-device-detect';
import { useOtherUserVersionStore } from '@store/OtherUserVersion';

/**
 * 请求接口拦截
 * 注：如需修改参数，请直接修改 config 中的值
 * @param config 请求配置
 * @returns 更新后的配置
 */
export const reqFulfillIntcpt = (config: InternalAxiosRequestConfig) => {
	const { url = '', method = 'get' } = config;

	config.headers['X-Delivery-Channel'] = 'other';
	if (isMobileOnly) {
		try {
			const userType = useUserTypeStore.getState().userType;
			config.headers['X-Delivery-Channel'] = UserChannelVersionMap[userType] ?? 'other';
		} catch (error) {
			console.warn('error getting user type for X-Delivery-Channel header:', error);
		}
	} else {
		try {
			const isGreenVersion = useOtherUserVersionStore.getState().isGreenVersion;
			config.headers['X-Delivery-Channel'] = isGreenVersion ? 'other' : 'seo';
		} catch (error) {
			console.warn('error getting web version for X-Delivery-Channel header:', error);
		}
	}

	if (CREDITS_CONSUMING_ENDPOINTS.some((re) => url.match(re))) {
		if (!HttpDependency.hasCredits()) {
			return Promise.reject(new Error('No credits left'));
		}
	}

	if (Optimize_ENDPOINTS.some((re) => url.match(re))) {
		const data = loadOneTimeData(LSK.TASK_OPTIMIZE) || {};
		HttpDependency.trackerOptimize({ imgId: config.data.imageId, ...data });
	}

	const isI18nEndpoint = I18N_ENDPOINTS.some((endpoint: string | RegExp) => {
		if (typeof endpoint === 'string') {
			return url.includes(endpoint);
		}
		return url.match(endpoint);
	});

	const curLocale = (getI18nSetting() ?? 'zh-CN').replace('-', '_');

	//拦截不支持的语言
	const curLocale_new =
		unSupportedLanguages.includes(curLocale) && isI18nEndpoint ? 'en_US' : curLocale;
	if (isI18nEndpoint && method === 'get') {
		config.params = config.params || {};
		config.params.language = curLocale_new;
	} else if (isI18nEndpoint && method === 'post') {
		config.data = config.data || {};
		config.data.language = curLocale_new;
	}

	const isCreateEndpoint = CREATE_ENDPOINTS.includes(url);
	if (isCreateEndpoint && method === 'post' && navigator.language.startsWith('en')) {
		config.data = {
			language: 'en_US',
			...config.data,
		};
	}

	handleGenerateParams(config);

	return config;
};

function handleGenerateParams(config: InternalAxiosRequestConfig) {
	const { url = '' } = config;
	const isGenerateEndpoint = GENERATE_ENDPOINTS.includes(url);
	if (!isGenerateEndpoint) return;

	// 生图回传
	HttpDependency.generateCallback();

	const generateData =
		url === '/api/ai-hub-server/conversation/images/generate' ? config.data?.req : config.data;

	if (generateData?.cnet) {
		generateData.cnet = generateData.cnet.filter((item: { imageUrl?: string }) => !!item.imageUrl);
	}
}

export const reqRejectIntcpt = (error: unknown) => {
	return Promise.reject(error);
};
